import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { RegexEnum } from "./../../../../../views/regex.enum";

import { AccommodationService } from "../../services/accommodation.service";

@Component({
  templateUrl: "./accommodation.component.html"
})
export class AccommodationComponent implements OnInit, OnDestroy {
  public accommodationList: any;
  public accommodation: any = {};
  public popUpType: string;
  public display = "none";
  public statusCode: Array<any> = [];
  public categories: any;
  public categoryErr = "";
  public accommodationErr = "";
  public accommodationDescErr = "";
  public codeErr = "";
  public informationErr = "";
  public displayOrderErr = "";
  public statusErr = "";
  public programNmErr = "";
  public msg: string = "";

  constructor(private accommodationService: AccommodationService) {}

  ngOnInit() {
    Observable.forkJoin(
      this.accommodationService.getAccommodation(),
      this.accommodationService.getAccommodationCategory()
    ).subscribe(([resp, catResponse]) => {
      this.accommodationList = resp.body;
      this.categories = catResponse.body;
    });

    this.statusCode = [
      { id: "A", code: "Active" },
      { id: "I", code: "Inactive" },
      { id: "", code: "Please Select" }
    ];
    this.resetForm();
  }

  openPopUp(item: any, type: string) {
    this.popUpType = type;
    // this.oldDisplayNumber = item.DISPLAY_ORDER_NO;

    if (this.popUpType === "Edit") {
      this.accommodation.ACCOMMODATION_ID = item.ACCOMMODATION_ID;
      this.accommodation.ACCOMMODATION_NM = item.ACCOMMODATION_NM;
      this.accommodation.ACCOMMODATION_DS = item.ACCOMMODATION_DS;
      this.accommodation.PROGRAM_NAMES = item.PROGRAM_NAMES;
      this.accommodation.ACCOMMODATION_CATEGORY_ID =
        item.ACCOMMODATION_CATEGORY_ID;
      this.accommodation.INFORMATION_TX = item.INFORMATION_TX;
      this.accommodation.ACCOMMODATION_CD = item.ACCOMMODATION_CD;
      this.accommodation.DISPLAY_ORDER_NO = item.DISPLAY_ORDER_NO;
      if (item.STATUS_CD === "Inactive") {
        this.accommodation.STATUS_CD = "I";
      } else if (item.STATUS_CD === "Active") {
        this.accommodation.STATUS_CD = "A";
      }
    } else {
      this.accommodation.ACCOMMODATION_NM = "";
      this.accommodation.ACCOMMODATION_DS = "";
      this.accommodation.PROGRAM_NAMES = "";
      this.accommodation.ACCOMMODATION_CATEGORY_ID = "";
      this.accommodation.INFORMATION_TX = "";
      this.accommodation.ACCOMMODATION_CD = "";
      this.accommodation.DISPLAY_ORDER_NO = "";
      this.accommodation.STATUS_CD = "";
    }

    this.display = "block";
  }

  closePopUpForm() {
    this.resetForm();
    this.display = "none";
  }

  resetForm() {
    this.msg = "";
    this.categoryErr = "";
    this.accommodationErr = "";
    this.accommodationDescErr = "";
    this.codeErr = "";
    this.informationErr = "";
    this.displayOrderErr = "";
    this.statusErr = "";
    this.programNmErr = "";
  }
  ngOnDestroy() {}

  save() {
    if (this.popUpType === "Add") {
      this.addRow();
    } else if (this.popUpType === "Edit") {
      this.editRow();
    }
  }

  addRow() {
    let isValidTrue: boolean = false;
    isValidTrue = this.validateForm("Add");
    if (isValidTrue) {
      // add addAccomodation
      this.accommodationService.addAccommodation(this.accommodation).subscribe(
        response => {
          if (response) {
            this.msg = "Accomodation has been added successfully.";
            this.getAccommodations();
          }
        },
        err => {}
      );
    }
  }

  editRow() {
    let isValidTrue: boolean = false;
    isValidTrue = this.validateForm("Edit");
    if (isValidTrue) {
      this.accommodationService.editAccommodation(this.accommodation).subscribe(
        response => {
          if (response) {
            this.msg = "All your changes have been saved.";
            this.getAccommodations();
          }
        },
        err => {}
      );
    }
  }

  validateForm(type) {
    const emptyOrOnlyWhiteSpace = new RegExp(RegexEnum.EMPTY_OR_WHITESPACE);
    if (type === "Add" || type === "Edit") {
      if (
        emptyOrOnlyWhiteSpace.test(this.accommodation.ACCOMMODATION_CATEGORY_ID)
      ) {
        this.categoryErr = "";
      } else {
        this.categoryErr = "Accommodation Category is required";
      }
      if (!emptyOrOnlyWhiteSpace.test(this.accommodation.ACCOMMODATION_NM)) {
        this.accommodationErr = "Accommodation is required";
      } else {
        const regexNm = new RegExp(RegexEnum.ALPHANUM_SP_50_PATTERN);

        if (regexNm.test(this.accommodation.ACCOMMODATION_NM)) {
          this.accommodationErr = "";
        } else {
          this.accommodationErr = "Accommodation is not valid";
        }
      }
      if (!emptyOrOnlyWhiteSpace.test(this.accommodation.ACCOMMODATION_CD)) {
        this.codeErr = "Accommodation Code is required";
      } else {
        const regexNm = new RegExp(RegexEnum.ALPHANUM_SP_50_PATTERN);

        if (regexNm.test(this.accommodation.ACCOMMODATION_CD)) {
          this.codeErr = "";
        } else {
          this.codeErr = "Accommodation Code is not valid";
        }
      }
    }

    if (!emptyOrOnlyWhiteSpace.test(this.accommodation.PROGRAM_NAMES)) {
      this.programNmErr = "Program Names is required";
    } else {
      const prgRegex = new RegExp(RegexEnum.PRG_NM_PATTERN);
      if (prgRegex.test(this.accommodation.PROGRAM_NAMES)) {
        this.programNmErr = "";
      } else {
        this.programNmErr = "Program Names is not valid";
      }
    }

    if (!emptyOrOnlyWhiteSpace.test(this.accommodation.ACCOMMODATION_DS)) {
      this.accommodationDescErr = "Accommodation Description is required";
    } else {
      const dsRegex = new RegExp(RegexEnum.ALPHANUM_SP_100_ACCOMM_PATTERN);
      if (dsRegex.test(this.accommodation.ACCOMMODATION_DS)) {
        this.accommodationDescErr = "";
      } else {
        this.accommodationDescErr = "Accommodation Description is not valid";
      }
    }

    const regexInfo = new RegExp(RegexEnum.ALPHANUM_SP_4000_ACCOMM_PATTERN);
    if (!emptyOrOnlyWhiteSpace.test(this.accommodation.INFORMATION_TX)) {
      this.informationErr = "Information Text is required";
    } else {
      if (regexInfo.test(this.accommodation.INFORMATION_TX)) {
        this.informationErr = "";
      } else {
        this.informationErr = "Information Text is not valid";
      }
    }

    if (!emptyOrOnlyWhiteSpace.test(this.accommodation.DISPLAY_ORDER_NO)) {
      this.displayOrderErr = "Display Order No is required";
    } else {
      const regex = new RegExp(RegexEnum.ONLY_NUMBER);
      if (regex.test(this.accommodation.DISPLAY_ORDER_NO)) {
        this.displayOrderErr = "";
        this.accommodation.DISPLAY_ORDER_NO = Number(
          this.accommodation.DISPLAY_ORDER_NO
        );
      } else {
        this.displayOrderErr = "Display Order is not valid";
      }
    }
    if (!emptyOrOnlyWhiteSpace.test(this.accommodation.STATUS_CD)) {
      this.statusErr = "Status is required";
    } else {
      this.statusErr = "";
    }

    if (
      this.categoryErr ||
      this.codeErr ||
      this.accommodationDescErr ||
      this.statusErr ||
      this.accommodationErr ||
      this.displayOrderErr ||
      this.programNmErr ||
      this.informationErr
    ) {
      return false;
    } else {
      return true;
    }
  }

  getAccommodations() {
    Observable.forkJoin(this.accommodationService.getAccommodation()).subscribe(
      ([resp]) => {
        this.accommodationList = resp.body;
        this.display = "none";
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/ba/Accommodation/accommodation.component.ts